<template>
  <div class="main-wrap">
    <!-- 金额总览区域 start -->
    <div class="header-info">
      <div class="title-primary">
        <div class="table">总采购金额</div>
        <div class="money">￥{{ procurementData.thismounthtotal }}</div>
      </div>
      <van-row class="title-secondary" type="flex" justify="space-between">
        <div>
          <div class="money">￥{{ procurementData.thismounthsubsist }}</div>
          <div class="table">本月应付账款总额</div>
          <br />
          <div class="money">￥{{ procurementData.thismonthamout }}</div>
          <div class="table">今日应付账款</div>
        </div>
        <div>
          <div class="money">￥{{ procurementData.totalsubsist }}</div>
          <div class="table">总应付账款</div>
          <br />
          <div class="money">￥{{ procurementData.todayamout }}</div>
          <div class="table">今日采购额</div>
        </div>
      </van-row>
    </div>
    <!-- 金额总览区域 end -->

    <!-- 卡片区域 start -->
    <DataReportTableCard :box="box"></DataReportTableCard>
    <!-- 卡片区域 end -->

    <!-- 图表区域 start -->
    <div class="echart-wrap">
      <div class="echart" id="echart01" ref="echart01"></div>
      <div class="echart" id="echart02" ref="echart02"></div>
    </div>
    <!-- 图表区域 end -->

    <!-- 列表区域 start -->
    <div class="footer-list">
      <van-list
        class="container list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        finished-text="没有更多了"
        error-text="点击重新加载"
        @load="onLoad"
      >
        <!-- 折叠列表区域 start -->
        <van-collapse class="collapseWrap" title-class="title-order" v-model="activeNames">
          <van-collapse-item
            class="item-wrap"
            :title="'订单号:' + item.code"
            :name="item.orderId"
            v-for="item in orderList"
            :key="item.orderId"
          >
            <van-row class="text">订单状态: {{ item.status }}</van-row>
            <van-row class="text">订单金额: {{ item.amount }}</van-row>
            <van-row class="text">本月代付款金额: {{ item.thismouthtopayamount }}</van-row>
            <van-row class="text">供应商: {{ item.supplier_name }}</van-row>
            <van-row class="text">订单类型: {{ item.type }}</van-row>
            <van-row class="text">采购数量: {{ item.num }}</van-row>
            <van-row class="text">
              <van-row>附件:</van-row>
              <van-row type="flex" gutter="20">
                <van-col span="8" v-for="(item, index) in item.file" :key="index">
                  <a :href="item">
                    <van-image
                      width="100"
                      height="100"
                      fit="contain"
                      :src="imgUrl + '/admin/ajax/icon?suffix=' + formatSuffix(item)"
                    />
                  </a>
                </van-col>
              </van-row>
            </van-row>
          </van-collapse-item>
        </van-collapse>
        <!-- 折叠列表区域 end -->
      </van-list>
    </div>
    <!-- 列表区域 end -->
  </div>
</template>

<script>
import { BASE_URL } from "../../../../config/global.js";
import DataReportTableCard from "../../../../components/DataReportTableCard.vue";
import echarts from "echarts";
export default {
  components: {
    DataReportTableCard,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      showEchart: false,
      page: 1,
      procurementData: {},
      box: [],
      year: {},
      mouth: {},
      activeNames: [],
      orderList: [],
      imgUrl: BASE_URL,
    };
  },
  methods: {
    /**
     * 初始化采购金额信息
     */
    // async initMoneyInfo() {
    //   // 在这发起请求
    //   // 获取采购员个人采购数据
    //   let { data } = await this.$post(this.$api.stGetBuyerById);
    //   // this.year = data.year;
    //   // this.mouth = data.mouth;
    //   this.procurementData = data;
    // },
    async initCardData() {
      let params = {
        id: this.$route.params.id,
      };
      let { data } = await this.$post(this.$api.stGetBuyerById, params);
      this.procurementData = data;
      this.box = data.box;
      this.year = data.year.lists;
      this.mouth = data.mouth.lists;
      this.echartInit();
    },
    /**
     * 渲染echart
     */
    echartInit() {
      this.$nextTick(() => {
        const list1 = this.mouth;
        const list2 = this.year;
        const echart01 = echarts.init(this.$refs.echart01);
        const echart02 = echarts.init(this.$refs.echart02);

        console.log(this.year.text);
        console.log(this.year.text);
        echart01.setOption({
          title: {
            text: this.mouth.text || "本月采购统计",
            left: "center",
            top: "8px",
            textStyle: {
              color: "#505050",
              fontSize: "14px",
            },
          },
          legend: {
            orient: "horizontal",
            left: "center",
            bottom: "5px",
            data: ["采购数量", "采购金额(CNY)"],
          },
          tooltip: { trigger: "axis" },
          color: ["#00baad", "#3c8ff7"],
          grid: {
            left: "20px",
            right: "20px",
            top: "30px",
            bottom: "45px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list1.dates,
          },
          yAxis: [
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "采购数量",
              type: "line",
              data: list1.num,
              yAxisIndex: 0,
              smooth: true,
            },
            {
              name: "采购金额(CNY)",
              type: "line",
              data: list1.price,
              yAxisIndex: 1,
              smooth: true,
            },
          ],
        });

        echart02.setOption({
          title: {
            text: this.year.text || "本年采购统计",
            left: "center",
            top: "8px",
            textStyle: {
              color: "#505050",
              fontSize: "14px",
            },
          },
          legend: {
            orient: "horizontal",
            left: "center",
            bottom: "5px",
            data: ["采购数量", "采购金额(CNY)"],
          },
          tooltip: { trigger: "axis" },
          color: ["#00baad", "#3c8ff7"],
          grid: {
            left: "20px",
            right: "20px",
            top: "30px",
            bottom: "45px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list2.dates,
          },
          yAxis: [
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "采购数量",
              type: "line",
              data: list2.num, // this.num TypeError
              yAxisIndex: 0,
              smooth: true,
            },
            {
              name: "采购金额(CNY)",
              type: "line",
              data: list2.price,
              yAxisIndex: 1,
              smooth: true,
            },
          ],
        });
      });
    },
    /**
     * 列表触底时触发
     */
    async onLoad() {
      // console.log("onLoad");
      // 请求列表数据
      let params = {
        id: this.$route.params.id,
        page: this.page,
      };
      try {
        let { data } = await this.$post(this.$api.stGetBuyerOrdelist, params);
        // 若数据已全部加载完毕
        if (data.length == 0) {
          this.finished = true;
        }
        if (this.page == 1) {
          this.orderList = [];
        }
        this.orderList.push(...data);
        this.page++;
      } catch (error) {
        console.log(error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    formatSuffix(url) {
      let arr = url.split("/");
      let filename = arr[arr.length - 1];
      arr = filename.split(".");
      let suffix = arr[arr.length - 1];
      return suffix;
    },
  },
  mounted() {
    this.initCardData();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: this.$route.params.name });
    });
  },
};
</script>

<style lang="scss" scoped>
$yellow: #ff8d1a;
$gary: #808080;
$pale-yellow: #fff4eb;
$pale-green: #dcf6f5;
$pale-blue: #edf3fc;
$pale-red: #ffedf1;
.main-wrap {
  min-height: 100%;
  background-color: #f6f4f2;
  .header-info {
    box-sizing: border-box;
    padding: 16px;
    font-size: 12px;
    color: #fff;
    background-color: #51596e;

    .title-primary {
      color: #fff;

      .money {
        text-align: center;
        font-family: "MicrosoftJhengHei";
        font-size: 30px;
        font-weight: 500;
      }
    }

    .title-secondary {
      margin-top: 30px;
      text-align: center;
      font-size: 12px;

      .money {
        margin-bottom: 6px;
        color: $yellow;
      }
    }
  }

  .echart-wrap {
    .echart {
      margin: 12px 0;
      height: 170px;
      background-color: #fff;
    }
  }

  .footer-list {
    .container {
      padding: 16px;
      .list-item {
        padding-top: 4px;
        padding-bottom: 8px;
        border-bottom: 1px solid #e5e5e5;

        .left {
          .abbreviation {
            color: #505050;
            font-size: 14px;
          }
          .fullName {
            color: #a6a6a6;
            font-size: 12px;
          }
        }

        .right {
          .value {
            font-size: 12px;
            color: $yellow;
          }
          .van-icon {
            margin-left: 8px;
            font-size: 16px;
          }
        }
      }

      .collapseWrap {
        .item-wrap {
          margin: 16px 0;

          .text {
            line-height: 2;
            font-size: 12px;
            color: #505050;
          }
        }
        ::v-deep.van-cell__title {
          font-size: 12px;
          color: #505050;
        }
      }
    }
  }
}
</style>
